<template>
  <img :src="lazyGoogleMapsSrc" class="pd-VendorSide_GoogleStaticMap" border="0" />
</template>

<script>
export default {
  name: "GoogleMapStatic",
  props: {
    center: {
      type: Object,
      required: true,
    },
    apikey: {
      required: true,
      type: String,
    },
    zoomlevel: {
      required: true,
      type: String,
    },
    mapstyle: {
      type: String,
      default: "",
    },
    markers: {
      type: Array,
      required: true,
    },
    cropToWidth: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      googleMapsBase: "https://maps.googleapis.com/maps/api/staticmap",
      mapType: "maptype=roadmap",
      observer: null,
      lazyGoogleMapsSrc: null,
      size: null,
    };
  },
  computed: {
    centerString() {
      return `center=${this.center.lat},${this.center.lng}`;
    },
    zoom() {
      return `zoom=${this.zoomlevel}`;
    },
    scale() {
      return `scale=2`;
    },
    markersString() {
      return this.markers
        .map(marker => {
          const mutableMarker = Object.assign({}, marker);
          const location = mutableMarker.location;
          delete mutableMarker.location;
          return `markers=${Object.entries(mutableMarker)
            .map(entry => entry.join(":"))
            .join("|")}|${location.lat},${location.lng}`;
        })
        .join("&");
    },
    key() {
      return `key=${this.apikey}`;
    },
    queryParameters() {
      return [
        this.centerString,
        this.markersString,
        this.zoom,
        this.size,
        this.scale,
        this.mapType,
        this.mapstyle,
        this.key,
      ].join("&");
    },
    googleMapsSrc() {
      return [this.googleMapsBase, this.queryParameters].join("?");
    },
  },
  mounted() {
    window.addEventListener("resize", this.setMapSize);
    this.setMapSize();
    if ("IntersectionObserver" in window) {
      this.installObserver();
    } else {
      this.setMapSrc();
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setMapSize);
  },
  methods: {
    setMapSize /* istanbul ignore next */() {
      this.size = `size=${this.$el.parentElement.clientWidth}x${Math.round(
        this.cropToWidth
          ? this.$el.parentElement.clientWidth / 2
          : this.$el.parentElement.clientHeight
      )}`;
    },
    setMapSrc() {
      this.lazyGoogleMapsSrc = this.googleMapsSrc;
    },
    onIntersecting(entries) {
      if (entries[0].isIntersecting) {
        this.setMapSrc();
        this.observer.unobserve(this.$el);
      }
    },
    installObserver() {
      this.observer = new IntersectionObserver(this.onIntersecting);
      this.observer.observe(this.$el);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.pd-VendorSide_GoogleStaticMap {
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: $border-radius;
}
</style>
